import React, { useState, useEffect } from 'react';
import './ChoosePlan.css';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Loader } from '@progress/kendo-react-indicators';


function ChoosePlan() {
  const [selectedPlan, setSelectedPlan] = useState('Gold Plan');
  const [selectedPlans, setSelectedPlans] = useState([]);
    const [plans, setPlans] = useState([]);
    const [businessId, setBussinessId] = useState(null);
    const [businessPhone, setBussinessPhone] = useState("");
    const [businessEmail, setBussinessEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
  
  
    useEffect(() => {
      let _companySession = localStorage.getItem("vs_UserSession");
      if (_companySession != undefined || _companySession != null) {
        _companySession = JSON.parse(_companySession);
        
        let businessId = _companySession.loginId;
        let loginNumber = _companySession.loginNumber;
        let loginEmail = _companySession.loginEmail;
  
        setBussinessId(businessId);
        setBussinessPhone(loginNumber);
        setBussinessEmail(loginEmail);
  
        console.log('baseURL:', global.webUrl);
  
      }
    }, []);
  
    useEffect(() => {
      const fetchPlans = async () => {
        try {
          const res = await fetch(`${global.API_STRIPEAPI_URL}getAllPlans?businessId=${businessId}`);
          const data = await res.json();
          setPlans(data.plans || []);
          const allPlans = data.plans || [];
          const filteredPlans = allPlans;
          
          setPlans(filteredPlans);
          
          
        } catch (err) {
          console.error("Error fetching plans:", err);
        }
      };
      if(businessId){
          fetchPlans();
      }
  
    }, [businessId]);
  
  
  
  
    const handleBuy = async (plan) => {
      const requestData = {
        businessId: businessId,
        businessPhone: businessPhone,
        businessEmail: businessEmail,
        priceId: plan.stripe_price_id,
        currency: plan.currency,
        setupAmount: plan.setup_amount * 100,
        baseURL: global.webUrl
      };
      setIsLoading(true);
      const response = await fetch(`${global.API_STRIPEAPI_URL}subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
  
      if (!response.ok) {
          // Backend returned an HTTP error (e.g. 400, 500)
          const errorData = await response.json();
          console.error("Subscription API error:", errorData);
          alert(errorData.message || "Failed to create subscription");
          return;
        }
  
        const session = await response.json();
        setIsLoading(false);
        // Redirect to the Stripe checkout page
        if (session && session.url) {
          window.location.href = session.url;
        } else {
          console.error("Invalid session response:", session);
          alert("Unable to start subscription. Please try again.");
        }
    };

  const formatCurrency = (amount, currency) => {
    return currency.toUpperCase() + ' ' + amount.toLocaleString();
  };

  const capitalizeInterval = (interval) => {
    return interval.charAt(0).toUpperCase() + interval.slice(1);
  };

  return (
    <div className="cp-app">
      <header className="cp-header">
        <div className="cpp-container">
          <h1 className="cp-main-title">Choose Your Plan</h1>
          <p className="cp-subtitle">Select the perfect plan for your business needs</p>
        </div>
      </header>

      <main className="cp-main">
        <div className="cpp-container">
          <div className="cp-plans-grid">
            {plans.map((plan) => (
              <div
                key={plan.stripe_price_id}
                className={`cp-plan-card ${plan.productName === 'Gold Plan' ? 'cp-popular' : ''} ${selectedPlan === plan.productName ? 'selected' : ''}`}
              >
                {plan.productName === 'Gold Plan' && (
                  <div className="cp-plan-badge">Most Popular</div>
                )}
                
                <div className="cp-plan-header" 
                onClick={() => setSelectedPlan(plan.productName)}>
                  <h2 className="cp-plan-name">{plan.productName}</h2>
                  <div className="cp-plan-type">Web + Mobile</div>
                </div>

                <div className="cp-pricing"
                onClick={() => setSelectedPlan(plan.productName)}>
                  <div className="cp-price-container">
                    <span className="cp-current-price">
                      {formatCurrency(plan.amount, plan.currency)}
                    </span>
                    <span className="cp-price-period">/ {capitalizeInterval(plan.interval_type)}</span>
                  </div>
                  {plan.setup_amount > 0 && (
                    <div className="cp-setup-fee">
                      {formatCurrency(plan.setup_amount, plan.currency)} one-time setup fee
                    </div>
                  )}
                </div>

                <ul className="cp-features-list"
                onClick={() => setSelectedPlan(plan.productName)}>
                  {plan.features.map((feature, index) => (
                    <li key={index} className={`cp-feature ${feature.is_available ? 'cp-included' : 'cp-excluded'}`}>
                      <span className="cp-feature-icon">
                        {feature.is_available ? '✓' : '✗'}
                      </span>
                      <span className="cp-feature-text">{feature.name}</span>
                    </li>
                  ))}
                </ul>

                <button
                  className={`cp-select-plan-btn ${plan.productName === 'Gold Plan' ? 'cp-popular-btn' : ''}`}
                  onClick={() => handleBuy(plan)}
                >
                  {selectedPlan === plan.productName ? 'Selected' : 'Choose Plan'}
                </button>
              </div>
            ))}
          </div>

          <div className="cp-bottom-section">
            <p className="cp-guarantee">30-day money-back guarantee</p>
            <p className="cp-support">Need help choosing? <a href="#contact">Contact our support team</a></p>
          </div>
        </div>
      </main>
      {
          isLoading && (
            <Dialog >
              <Loader type="converging-spinner" />
            </Dialog>
          )
        }
    </div>
  );
}

export default ChoosePlan;